import { ApolloLink } from './ApolloLink';

export const from = ApolloLink.from;
